<template>
  <div class="page-content">
    <h1>{{ $t('v.actionLog.title') }}</h1>

    <v-card>
      <v-card-section>
        <v-card-title>{{ titleActions }}</v-card-title>
        <v-card-body v-loading="actionLogLoading">
          <v-action-log-list :list="actionLog" />

          <template v-if="actionLogTotalPage">
            <hr />

            <v-row justify="center" class="pagination-wrapper">
              <v-pagination
                layout="prev, pager, next"
                :page-size="1"
                :current-page="actionLogCurrentPage"
                :total="actionLogTotalPage"
                :disabled="actionLogLoading"
                @current-change="changeCurrentPage"
              />
            </v-row>
          </template>
        </v-card-body>
      </v-card-section>
    </v-card>
  </div>
</template>

<script>
import VActionLogList from '@/components/ActionLog/VActionLogList.vue'
import VPagination from '@/components/common/VPagination.vue'
import VCard from '@/components/common/VCard.vue'
import VCardSection from '@/components/common/VCardSection.vue'
import VCardTitle from '@/components/common/VCardTitle.vue'
import VCardBody from '@/components/common/VCardBody.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import storeUtils from '@/mixins/storeUtils'

export default {
  name: 'ActionLog',

  components: {
    VActionLogList,
    VPagination,
    VCard,
    VCardSection,
    VCardTitle,
    VCardBody,
    VRow
  },

  mixins: [storeUtils],

  computed: {
    titleActions() {
      return this.$t('v.actionLog.titleActions').toUpperCase()
    },
    actionLog() {
      return this.$store.state[types.ACTION_LOG].list
    },
    actionLogLoading() {
      return this.$store.state[types.ACTION_LOG].loading
    },
    actionLogCurrentPage() {
      return this.$store.state[types.ACTION_LOG].params.currentPage
    },
    actionLogTotalPage() {
      return this.$store.state[types.ACTION_LOG].params.totalPage
    }
  },

  created() {
    this.fetchLog(types.ACTION_LOG)
  },

  destroyed() {
    this.clearLog(types.ACTION_LOG)
  },

  methods: {
    changeCurrentPage(value) {
      const params = {
        currentPage: value
      }

      this.updateParams(types.ACTION_LOG, params)
      this.fetchLog(types.ACTION_LOG)
    },

    fetchLog(name) {
      const { loading } = this.$store.state[name]

      if (!loading) {
        const { currentPage: page, limit } = this.$store.state[name].params
        this.$store.dispatch(types.FETCH_ACTION_LOG, { name, page, limit })
      }
    },

    clearLog(name) {
      this.setList(name, [])
      this.updateParams(name, {
        currentPage: 1,
        totalPage: null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.log {
  padding: 15px 0 30px;
}
.pagination-wrapper {
  margin-top: 10px;
}
.card__body {
  position: relative;
}
</style>
